export default {
  // YouTube Link Generator
  'link.mainTitle': 'YouTube Timestamp Link Generator',
  'link.mainTitleSEO': 'YouTube Timestamp Link Generator - Create Shareable Video Links',
  'link.subtitle': 'Generate YouTube links that start at specific times - perfect for sharing',

  // Link Generator Tool
  'link.generatorTitle': 'Create YouTube Link with Timestamp',
  'link.pasteUrl': 'Paste YouTube URL:',
  'link.urlPlaceholder': 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  'link.startTime': 'Start Time:',
  'link.hours': 'Hours',
  'link.minutes': 'Minutes',
  'link.seconds': 'Seconds',
  'link.orEnterSeconds': 'Or enter total seconds:',
  'link.secondsPlaceholder': 'e.g., 90',

  // Output Section
  'link.generatedLinks': 'Generated Shareable Links:',
  'link.shortLink': 'Short Link (Recommended):',
  'link.fullLink': 'Full Link:',
  'link.embedCode': 'Embed Code:',
  'link.preview': 'Preview:',
  'link.copyLink': 'Copy Link',
  'link.copyEmbed': 'Copy Embed',

  // URL Formats
  'link.urlFormats': 'YouTube Timestamp URL Formats Explained',
  'link.format1Title': '1. Query Parameter Format (?t=)',
  'link.format1Desc': 'Add ?t= or &t= to any YouTube URL:',
  'link.format1Example1': '?t=90 - 90 seconds (1 minute 30 seconds)',
  'link.format1Example2': '?t=1m30s - 1 minute 30 seconds',
  'link.format1Example3': '?t=1h5m30s - 1 hour 5 minutes 30 seconds',

  'link.format2Title': '2. Hash Fragment Format (#t=)',
  'link.format2Desc': 'Older format using #t=:',

  'link.format3Title': '3. Mobile App Deep Links',
  'link.format3Desc': 'For mobile sharing:',

  'link.format4Title': '4. Embed URL with Start Parameter',
  'link.format4Desc': 'For embedded videos:',

  // Use Cases
  'link.useCases': 'When to Use Timestamped Links',
  'link.useCase1Title': '📱 Social Media Sharing',
  'link.useCase1Desc': 'Share exact moments on Twitter, Facebook, Reddit',

  'link.useCase2Title': '📧 Email References',
  'link.useCase2Desc': 'Send colleagues to specific parts of training videos',

  'link.useCase3Title': '📝 Blog Citations',
  'link.useCase3Desc': 'Link to specific video evidence in articles',

  'link.useCase4Title': '💬 Forum Discussions',
  'link.useCase4Desc': 'Reference exact moments in video debates',

  'link.useCase5Title': '🎓 Educational Content',
  'link.useCase5Desc': 'Direct students to specific lesson segments',

  'link.useCase6Title': '🎬 Video Reviews',
  'link.useCase6Desc': 'Highlight specific scenes or moments',

  // FAQ
  'link.faq': 'YouTube Timestamp Link FAQ',

  'link.faq.q1': 'Do YouTube timestamp links work on mobile?',
  'link.faq.a1': 'Yes! Both ?t= and #t= formats work on mobile browsers and the YouTube app. The link will open in the app if installed, or in the mobile browser.',

  'link.faq.q2': 'Can I use timestamp links in embedded videos?',
  'link.faq.a2': 'Yes, use the start= parameter in embed URLs: <iframe src="https://www.youtube.com/embed/VIDEO_ID?start=90"></iframe>',

  'link.faq.q3': 'Do timestamp links work with YouTube Shorts?',
  'link.faq.a3': 'No, YouTube Shorts don\'t currently support timestamp parameters. Timestamp links only work with regular YouTube videos.',

  'link.faq.q4': 'Will the timestamp link always work?',
  'link.faq.a4': 'Yes, as long as the video remains public and accessible, the timestamp link will continue to work. If the video is deleted or made private, the link won\'t work.',

  'link.faq.q5': 'Can I add an end time to the link?',
  'link.faq.a5': 'Yes, you can add &end= parameter: ?t=90&end=180 will play from 1:30 to 3:00',

  'link.faq.q6': 'Which format should I use - ?t= or #t=?',
  'link.faq.a6': 'Use ?t= (query parameter) format. It\'s the modern standard and works more reliably across all platforms. The #t= format is older and less compatible.',

  // Related Tools
  'link.relatedTools': 'Related YouTube Tools',
  'link.needChapters': 'Need to Create Video Chapters?',
  'link.needChaptersDesc': 'Use our YouTube Timestamp Generator for creating chapter timestamps for video descriptions and comments.',
  'link.checkGenerator': 'Check out YouTube Timestamp Generator',

  'link.needUnixTime': 'Working with Unix Timestamps?',
  'link.needUnixTimeDesc': 'Convert Unix timestamps to readable dates with our timestamp converter.',

  // How to Use
  'link.howToUse': 'How to Create YouTube Timestamp Links',
  'link.step1': 'Copy the YouTube video URL',
  'link.step1Desc': 'Get the URL from the browser address bar or the share button',

  'link.step2': 'Enter the start time',
  'link.step2Desc': 'Use the time picker or enter seconds directly',

  'link.step3': 'Copy your preferred link format',
  'link.step3Desc': 'Choose between short link, full link, or embed code',

  'link.step4': 'Share anywhere!',
  'link.step4Desc': 'Works on social media, email, forums, and messaging apps',

  // Additional Tips
  'link.tips': 'Pro Tips',
  'link.tip1': '💡 Use short links (youtu.be) for social media - they\'re cleaner and take less space',
  'link.tip2': '💡 Right-click on a YouTube video and select "Copy video URL at current time" for quick sharing',
  'link.tip3': '💡 Timestamps work with playlists too: just add &t=90 to playlist URLs',
  'link.tip4': '💡 You can combine with other parameters like &list= for playlists or &autoplay=1',
};
